
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index_mZdk8D6mh_FP0fxk1vN_xXgex1NVbiK_GIcdMEdqMAMeta } from "/home/runner/work/augwa/augwa/web-auth/app/pages/index.vue?macro=true";
import { default as indexCjXpSpNmB7LKOc2QvoRCaXrF0MdjM7Nx6_rzF2M_qZwMeta } from "/home/runner/work/augwa/augwa/web-auth/app/pages/[domain]/index.vue?macro=true";
import { default as indexQFK1GifKkasZH_dtFBfIL7ojdiA1oJvxyL0A22HfzdEMeta } from "/home/runner/work/augwa/augwa/web-auth/app/pages/[domain]/register/index.vue?macro=true";
import { default as indexOZg0V5Q2C_LlkwlDGqya6CwFwUUEFr_Hddhn3DOYhbMMeta } from "/home/runner/work/augwa/augwa/web-auth/app/pages/[domain]/reset-password/index.vue?macro=true";
import { default as _91domain_93vDBwNb0rl1kyYqHFIxxuz3_aaMsca_cGS6rU3euM42QMeta } from "/home/runner/work/augwa/augwa/web-auth/app/pages/[domain].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: index_mZdk8D6mh_FP0fxk1vN_xXgex1NVbiK_GIcdMEdqMAMeta || {},
    component: () => import("/home/runner/work/augwa/augwa/web-auth/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: index_mZdk8D6mh_FP0fxk1vN_xXgex1NVbiK_GIcdMEdqMAMeta || {},
    component: () => import("/home/runner/work/augwa/augwa/web-auth/app/pages/index.vue")
  },
  {
    name: _91domain_93vDBwNb0rl1kyYqHFIxxuz3_aaMsca_cGS6rU3euM42QMeta?.name,
    path: "/en/:domain()",
    meta: _91domain_93vDBwNb0rl1kyYqHFIxxuz3_aaMsca_cGS6rU3euM42QMeta || {},
    component: () => import("/home/runner/work/augwa/augwa/web-auth/app/pages/[domain].vue"),
    children: [
  {
    name: "domain___en",
    path: "",
    component: () => import("/home/runner/work/augwa/augwa/web-auth/app/pages/[domain]/index.vue")
  },
  {
    name: "domain-register___en",
    path: "register",
    component: () => import("/home/runner/work/augwa/augwa/web-auth/app/pages/[domain]/register/index.vue")
  },
  {
    name: "domain-reset-password___en",
    path: "reset-password",
    component: () => import("/home/runner/work/augwa/augwa/web-auth/app/pages/[domain]/reset-password/index.vue")
  }
]
  }
]